import * as React from "react"
import PropTypes from "prop-types"
import Navbar from "./navBar"

const Header = ({ siteTitle, pageInfo }) => (
  <header>
    <Navbar siteTitle={siteTitle} pageInfo={pageInfo} />
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
